// import React, { useState, useEffect } from "react";
// import { useAuth } from "../context/AuthContext";
// import { useNavigate, Link } from "react-router-dom";
// import { useCookies } from "react-cookie";
// // import Header from "../componentbook/HeaderFilesBook/HeaderBook";
// // import Footer from "../component/HomePage01/Footer/Footer";
// import LoadingSpinner from "../components/LoadingSpinner";
// import classes from "./TypingMyOrders.module.css";
// import axios from "axios";

// function TypingMyOrders() {
//   const navigate = useNavigate();
//   const { user } = useAuth();
//   const [cookies] = useCookies(["token"]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState("");
//   const [productData, setProductData] = useState([]); // Initialize as an empty array

//   const checkAccessTypingProduct = async () => {
//     try {
//       const response = await axios.post(
//         "https://auth.ssccglpinnacle.com/api/checkAccessTypingProduct",
//         { product_id: "999" },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${cookies.token}`,
//           },
//         }
//       );

//       if (response.data.access === "access") {
//         // Assuming response.data contains an array of products under 'purchasedProducts'
//         setProductData(response.data);
//       } else {
//         setMessage("You do not have access to this product.");
//       }
//     } catch (error) {
//       console.error("Error checking product access:", error);
//       setMessage("An error occurred while checking access.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   checkAccessTypingProduct();

//   if (loading) {
//     return <LoadingSpinner />;
//   }

//   const handleOrderClick = (access) => {
//     if (access === "access") {
//       navigate("/typingexamselection");
//     }
//   };

//   return (
//     <>
//       {/* <Header /> */}
//       <div className={classes.container}>
//         <div className={classes.header}>
//           <div className={classes.heading_title}>
//             <h1 className={classes.title}>Purchased Typing Software</h1>
//           </div>
//           <div className={classes.button_div}>
//             <button className={classes.button_link}>
//               <Link
//                 to="https://testportal.ssccglpinnacle.com/myorders"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Purchased Test Series
//               </Link>
//             </button>
//             <button className={classes.button_link}>
//               <Link
//                 to="https://ebooks.ssccglpinnacle.com/myorders"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Purchased E-Books
//               </Link>
//             </button>
//             <button className={classes.button_link}>
//               <Link
//                 to="https://videos.ssccglpinnacle.com/myorders"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Purchased Video Course
//               </Link>
//             </button>
//             <button className={classes.button_books}>
//               <Link
//                 to="https://books.ssccglpinnacle.com/purchase-book"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Purchased Books
//               </Link>
//             </button>
//           </div>
//         </div>
//         {message && <p className={classes.message}>{message}</p>}
//         <table className={classes.table}>
//           <thead>
//             <tr>
//               <th>Product ID</th>
//               <th>Product Name</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{"999"}</td>
//               <td
//                 onClick={() => handleOrderClick(productData.access)}
//                 style={{ cursor: "pointer", color: "blue" }}
//               >
//                 {"Typing Software"}
//               </td>
//               <td>{productData.access}</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//       {/* <Footer /> */}
//     </>
//   );
// }

// export default TypingMyOrders;
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import LoadingSpinner from "../components/LoadingSpinner";
import axios from "axios";
import Header from "../components/Header/Header";

function TypingMyOrders() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [cookies] = useCookies(["token"]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [productData, setProductData] = useState([]);

  useEffect(() => {
    const checkAccessTypingProduct = async () => {
      try {
        const response = await axios.post(
          "https://auth.ssccglpinnacle.com/api/checkAccessTypingProduct",
          { product_id: "999" },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${cookies.token}`,
            },
          }
        );

        if (response.data.access === "access") {
          setProductData(response.data);
        } else {
          setMessage("You do not have access to this product.");
        }
      } catch (error) {
        console.error("Error checking product access:", error);
        setMessage("An error occurred while checking access.");
      } finally {
        setLoading(false);
      }
    };

    checkAccessTypingProduct();
  }, [cookies.token]);

  const handleOrderClick = (access) => {
    if (access === "access") {
      navigate("/typingexamselection");
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <Header />

      <div className="max-w-4xl mx-auto mt-10 px-4">
        <div className="bg-white shadow-md rounded-md p-6">
          <h1 className="text-2xl font-bold mb-6 text-center text-blue-800">
            Purchased Typing Software
          </h1>

          <div className="flex flex-wrap gap-4 justify-center mb-8">
            <a
              href="https://testportal.ssccglpinnacle.com/myorders"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
            >
              Purchased Test Series
            </a>
            <a
              href="https://ebooks.ssccglpinnacle.com/myorder"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
            >
              Purchased E-Books
            </a>
            <a
              href="https://videos.ssccglpinnacle.com/myorders"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
            >
              Purchased Video Course
            </a>
            <a
              href="https://books.ssccglpinnacle.com/purchase-book"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm"
            >
              Purchased Books
            </a>
          </div>

          {message && (
            <p className="text-red-600 text-center font-medium mb-4">
              {message}
            </p>
          )}

          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border px-4 py-2 text-left text-sm">
                    Product ID
                  </th>
                  <th className="border px-4 py-2 text-left text-sm">
                    Product Name
                  </th>
                  <th className="border px-4 py-2 text-left text-sm">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-4 py-2 text-sm">999</td>
                  <td
                    className="border px-4 py-2 text-sm text-blue-600 cursor-pointer hover:underline"
                    onClick={() => handleOrderClick(productData.access)}
                  >
                    Typing Software
                  </td>
                  <td className="border px-4 py-2 text-sm">
                    {productData.access}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default TypingMyOrders;
